/**
 * @generated SignedSource<<ec1f0c9f1241c6fa049e41bd59210840>>
 * @relayHash 2b65d1bc6af8a5b24528e315a236250f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c5175af020c79b26302d5ffa3ae68ee40c220659f9948b0647fe7e453403671f

import type { ConcreteRequest } from 'relay-runtime';
export type GraphIntegrationDirectoryItemType = "ACTION" | "CUSTOM_SKILL" | "MCP_SERVER" | "MCP_TOOL" | "PLATFORM_SKILL" | "SKILL" | "%future added value";
export type GraphIntegrationSkillColor = "BLUE" | "DEFAULT" | "GRAY" | "GREEN" | "LIME" | "MAGENTA" | "ORANGE" | "PURPLE" | "RED" | "TEAL" | "YELLOW" | "%future added value";
export type GraphIntegrationSurface = "AUTOMATION" | "POLLINATOR" | "ROVO" | "ROVO_AGENTS" | "ROVO_CLAW" | "STUDIO" | "%future added value";
export type skillMetadataProviderQuery$variables = {
  cloudId: string;
  first: number;
  relevantFor: ReadonlyArray<GraphIntegrationDirectoryItemType>;
  shouldSkip: boolean;
  surface?: GraphIntegrationSurface | null;
  tags?: ReadonlyArray<string> | null;
};
export type skillMetadataProviderQuery$data = {
  readonly graphIntegration_componentDirectoryItems?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: "GraphIntegrationSkillDirectoryItem";
        readonly color: GraphIntegrationSkillColor | null;
        readonly description: string | null;
        readonly iconUrl: string | null;
        readonly id: string;
        readonly integrationKey: {
          readonly displayName: string;
          readonly iconUrl: string | null;
        } | null;
        readonly name: string;
        readonly slashCommand: string | null;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      } | null;
    }>;
    readonly pageInfo: {
      readonly endCursor: string | null;
      readonly hasNextPage: boolean;
      readonly hasPreviousPage: boolean;
      readonly startCursor: string | null;
    };
  } | null;
};
export type skillMetadataProviderQuery = {
  response: skillMetadataProviderQuery$data;
  variables: skillMetadataProviderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "relevantFor"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldSkip"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "surface"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tags"
},
v6 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "relevantFor",
    "variableName": "relevantFor"
  },
  {
    "kind": "Variable",
    "name": "surface",
    "variableName": "surface"
  },
  {
    "kind": "Variable",
    "name": "tags",
    "variableName": "tags"
  }
],
v7 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v8 = {
  "kind": "ScalarField",
  "name": "id"
},
v9 = {
  "kind": "ScalarField",
  "name": "slashCommand"
},
v10 = {
  "kind": "ScalarField",
  "name": "name"
},
v11 = {
  "kind": "ScalarField",
  "name": "description"
},
v12 = {
  "kind": "ScalarField",
  "name": "iconUrl"
},
v13 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v14 = {
  "kind": "ScalarField",
  "name": "color"
},
v15 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    },
    {
      "kind": "ScalarField",
      "name": "hasPreviousPage"
    },
    {
      "kind": "ScalarField",
      "name": "startCursor"
    },
    {
      "kind": "ScalarField",
      "name": "endCursor"
    }
  ]
},
v16 = [
  (v8/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "skillMetadataProviderQuery",
    "selections": [
      {
        "condition": "shouldSkip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v6/*: any*/),
            "concreteType": "GraphIntegrationDirectoryItemConnection",
            "kind": "LinkedField",
            "name": "graphIntegration_componentDirectoryItems",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphIntegrationDirectoryItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/),
                          {
                            "concreteType": "GraphIntegrationDirectoryFilterDimension",
                            "kind": "LinkedField",
                            "name": "integrationKey",
                            "plural": false,
                            "selections": [
                              (v13/*: any*/),
                              (v12/*: any*/)
                            ]
                          },
                          (v14/*: any*/)
                        ],
                        "type": "GraphIntegrationSkillDirectoryItem"
                      }
                    ]
                  }
                ]
              },
              (v15/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "skillMetadataProviderQuery",
    "selections": [
      {
        "condition": "shouldSkip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v6/*: any*/),
            "concreteType": "GraphIntegrationDirectoryItemConnection",
            "kind": "LinkedField",
            "name": "graphIntegration_componentDirectoryItems",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphIntegrationDirectoryItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/),
                          {
                            "concreteType": "GraphIntegrationDirectoryFilterDimension",
                            "kind": "LinkedField",
                            "name": "integrationKey",
                            "plural": false,
                            "selections": [
                              (v13/*: any*/),
                              (v12/*: any*/),
                              (v8/*: any*/)
                            ]
                          },
                          (v14/*: any*/)
                        ],
                        "type": "GraphIntegrationSkillDirectoryItem"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v16/*: any*/),
                        "type": "GraphIntegrationActionDirectoryItem"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v16/*: any*/),
                        "type": "GraphIntegrationMcpServer"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v16/*: any*/),
                        "type": "GraphIntegrationMcpTool"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v16/*: any*/),
                        "type": "GraphIntegrationSkillItem"
                      }
                    ]
                  }
                ]
              },
              (v15/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "c5175af020c79b26302d5ffa3ae68ee40c220659f9948b0647fe7e453403671f",
    "metadata": {},
    "name": "skillMetadataProviderQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "a886cc1a7f4cca0c76a7569f4eaae42e";

export default node;
